var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudAgent(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.7,
    height: 17.7,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#1C274C",
    strokeLinecap: "round",
    strokeWidth: 1.7,
    d: "M13.231 5.877a5.765 5.765 0 0 1 1.905-.321c.654 0 1.283.109 1.87.309M5.965 8.459a4.351 4.351 0 0 0-.83-.08C2.769 8.38.85 10.276.85 12.615c0 2.339 1.919 4.235 4.286 4.235h10c3.156 0 5.714-2.528 5.714-5.647 0-2.472-1.607-4.573-3.845-5.338M5.966 8.459a5.577 5.577 0 0 1-.354-1.962C5.612 3.378 8.17.85 11.326.85c2.94 0 5.361 2.194 5.68 5.015M5.965 8.459a4.29 4.29 0 0 1 1.55.634"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudAgent);
export default __webpack_public_path__ + "static/media/cloud_agent.bc24b7d7758b226c60752c245efadea2.svg";
export { ForwardRef as ReactComponent };